// La page d'un test de Projector, dans la nouvelle interface (9 octobre 2026) :
// `pages/epure/ETest.vue`. Les phrases de verdict s'écrivent à partir des
// chiffres du test ; le reste du vocabulaire du test vient de `projector.test`.
export default {
  titre: 'Test',
  ariane: {
    aria: 'Fil d’Ariane',
    pays: 'Pays de l’export',
  },
  entete: {
    luLe: 'Lu le {jour}',
    lanceLe: 'Lancé le {jour}',
    prepareLe: 'Préparé le {jour}',
    comparables: 'face à {n} comparable | face à {n} comparable | face à {n} comparables',
    pays: '{n} pays | {n} pays | {n} pays',
    etalons: '{n} format étalon | {n} format étalon | {n} formats étalons',
    publics: 'interrogés : {noms}',
  },
  lu: {
    titre: 'Ce que le panel a lu',
    question: 'La question posée',
    questions: 'Les questions posées',
    comparable: 'Comparable, lu sans son titre',
    lireTout: 'Lire tout',
    reduire: 'Réduire',
  },
  relecture: {
    reponses: 'Les réponses proposées',
    bloquants: 'À corriger avant de lancer',
    avertissements: 'À relire',
    limites: 'Ce que ce test ne dira pas',
  },
  entre: 'entre {bas} et {haut} %',
  verdict: {
    papier: {
      ecart: 'Les {haut} le regarderaient le plus ({pctHaut}), les {bas} le moins ({pctBas}).',
      egal: 'D’une cible à l’autre, l’envie reste proche : de {bas} à {haut}.',
      uneCible: '{pct} des {cible} le regarderaient.',
      vosCibles: '{pct} de vos cibles le regarderaient.',
      panel: '{pct} du panel le regarderait.',
      classeTete: 'Face à son comparable, lu à l’aveugle, {titre} passe devant. | Face à son comparable, lu à l’aveugle, {titre} passe devant. | Face à ses {n} comparables, lus à l’aveugle, {titre} arrive en tête.',
      classeDernier: 'Face à son comparable, lu à l’aveugle, {titre} reste derrière. | Face à son comparable, lu à l’aveugle, {titre} reste derrière. | Face à ses {n} comparables, lus à l’aveugle, {titre} arrive dernier.',
      classeRang: 'Face à ses {n} comparables, lus à l’aveugle, {titre} arrive {rang} sur {sur}.',
    },
    ab: {
      aucune: 'Aucune version ne se détache.',
      emporteDe: '{nom} l’emporte de {n} point. | {nom} l’emporte de {n} point. | {nom} l’emporte de {n} points.',
      ecartChez: 'L’écart se fait surtout chez les {cible} ({ecart}).',
      aucuneRetient: '{pct} du panel n’en choisit aucune.',
    },
    episode: {
      fin: '{pct} regardent l’épisode jusqu’au bout.',
      suite: '{pct} regarderaient l’épisode suivant.',
      fort: 'Le moment qui accroche le plus : la séquence {n} ({horaire}), pour {pct}.',
      faible: 'Celui où l’on a le plus envie de décrocher : la séquence {n} ({horaire}), pour {pct}.',
    },
    pilote: {
      fin: '{pct} le regardent jusqu’au bout.',
      decrochage: 'Le plus fort décrochage se fait entre « {a} » et « {b} » ({ecart}).',
    },
    sortie: {
      tete: '{pct} des {cible} regarderaient {titre} dans sa première semaine sur {plateforme}{entre}, soit {personnes} personnes.',
      teteSansPersonnes: '{pct} des {cible} regarderaient {titre} dans sa première semaine sur {plateforme}{entre}.',
      desLaSortie: 'Dès sa sortie : {pct}.',
    },
    soiree: {
      projetee: '{programme} : {pct} de part d’audience projetée sur les {cible}{entre}.',
      simulee: '{programme} : {pct} de part d’audience simulée sur les {cible}{entre}.',
      mesureDans: 'La mesure publiée, {mesure}, tombe dans la fourchette.',
      mesureHors: 'La mesure publiée, {mesure}, sort de la fourchette.',
    },
  },
  episode: {
    jusquAuBout: 'le regardent jusqu’au bout',
    aime: 'l’ont aimé',
    suite: 'regarderaient l’épisode suivant',
    retention: 'Qui regarde encore, séquence par séquence',
    survol: 'Survolez une séquence pour voir ses moments forts et ses envies de décrocher.',
    restants: '{pct} regardent encore',
    zone: 'Séquence {n} : {restants} regardent encore ; moment fort pour {fort}, envie de décrocher pour {faible}.',
    sequence: 'Séquence {n}',
    vignette: 'Une image de la séquence {n}',
    fort: 'Moment fort',
    faible: 'Envie de décrocher',
  },
  sortie: {
    titre: 'Sortie sur {plateforme}',
    premiereSemaine: 'dans sa première semaine',
    personnes: '{valeur} personnes{bornes}',
    quand: 'Quand ils le regarderaient',
    option: {
      desSaSortie: 'Dès sa sortie',
      dansLaSemaine: 'Dans la semaine qui suit',
      plusTard: 'Plus tard',
      pasDuTout: 'Pas du tout',
    },
    entete: 'sur {plateforme} le {jour}',
    canaux: {
      titre: 'Canal par canal',
      aide: 'La part qui le regarderait dans sa première semaine, selon l’endroit où elle le rencontre.',
      canal: 'Canal',
    },
    poches: {
      titre: 'Là où ça prend',
      aide: 'Les publics qui le regarderaient le plus vite, selon ce qu’ils aiment déjà et l’endroit où ils le rencontrent, chacun face à tout son public.',
      nom: '{affinite}, {public}',
      sur: 'sur {canal}',
      tousCanaux: 'tous canaux confondus',
      contre: 'contre {pct} pour l’ensemble des {public}',
      accident: 'Là où ça prend le plus : {nom}, {ou}. {pct} le regarderaient dans sa première semaine, contre {reference} pour l’ensemble des {public}.',
      accidentSansReference: 'Là où ça prend le plus : {nom}, {ou}. {pct} le regarderaient dans sa première semaine.',
    },
  },
  // Ce sur quoi une Diffusion s'appuie (15 octobre 2026).
  // Les confirmations (15 octobre 2026).
  confirmer: {
    archiver: {
      titre: 'Archiver ce test ?',
      texte: 'Il quitte la fiche du format et son escalier. Il ne se relance plus.',
    },
    sceller: {
      titre: 'Sceller la projection ?',
      texte: 'La projection est figée et horodatée avant la diffusion. Elle ne se modifie plus, et une soirée n’en a qu’une.',
    },
  },
  appuis: {
    titre: 'Ce sur quoi elle s’appuie',
    bloc: {
      format_papier: 'Format papier',
      ab: 'A/B Testing',
      pilote: 'Épisode',
    },
    envie: 'en ont envie, sur le pitch',
    versionGagnante: 'en ont envie avec « {version} », la version gagnante',
    versionChoisie: 'en ont envie avec « {version} », la version retenue',
    jusquAuBout: 'vont jusqu’au bout de l’épisode',
    episodesVus: 'environ {n} épisodes vus sur {sur}',
    voir: 'Voir l’étude',
    sortie: 'Les jumeaux de cette Diffusion ont vu le programme tel que ces études l’ont fait gagner.',
    soiree: 'La soirée se mesure sur le guide des programmes : ces études éclairent le résultat sans changer ce que les jumeaux ont vu.',
  },
  vitrine: {
    verdict: '{pct} des {cible} lanceraient {titre} en premier sur {canaux}, face à ce qui y sort ou s’y regarde le plus ({rang}).',
    lancent: 'le lancent en premier',
    rang: '{rang}e sur {sur}',
    rangPremier: '1er sur {sur}',
    rangCanal: '{rang} ({canal})',
    et: ' et ',
    titre: 'Face à ce qui sort',
    aide: 'Ce que chaque public lance en premier, canal par canal, parmi ce qui y sort ou s’y regarde le plus cette semaine.',
    pochesAide: 'Les publics qui le lancent le plus souvent en premier, selon ce qu’ils aiment déjà et l’endroit où ils le rencontrent, chacun face à tout son public.',
    accident: 'Là où ça prend le plus : {nom}, {ou}. {pct} le lanceraient en premier, contre {reference} pour l’ensemble des {public}.',
    accidentSansReference: 'Là où ça prend le plus : {nom}, {ou}. {pct} le lanceraient en premier.',
  },
  papier: {
    leRegarderaient: 'le regarderaient',
    tropPeu: 'Trop peu de réponses pour un chiffre',
    indifferents: '{pct} d’indifférents',
    indifferentsTotal: '{pct} d’indifférents (« ça m’est égal »)',
    duo: 'Chez les 3-7 ans, {reclame} le réclameraient ; {retient} le regarderaient avec l’accord de leurs parents.',
    reponses: '{n} réponse | {n} réponse | {n} réponses',
  },
  classe: {
    rang: '{rang} sur {sur}',
    aveugle: 'Les mêmes jumeaux ont lu chaque programme, sans son titre.',
  },
  ab: {
    envie: 'ont envie de regarder',
    choisissent: 'la choisissent',
    lEmporte: 'L’emporte',
    devanceDePeu: 'Devance de peu',
    reference: 'Référence',
    enTete: 'En tête',
    ecartReference: '{ecart} face à {ref}',
    indifferents: '{pct} d’indifférents',
  },
  retenir: {
    titre: 'À retenir',
    cibleGagne: 'Chez les {cible}, {nom} l’emporte : {a} contre {b}.',
    cibleEgale: 'Chez les {cible}, les versions font jeu égal : de {bas} à {haut}.',
    effetTalent: '{nom} : {ecart} face à {ref}.',
    talentSansEffet: 'Aucun talent ne déplace l’envie de cinq points ou plus face à {ref}.',
    papierPlus: '{nom} donne plus envie que le texte seul : {papier} sur le papier, {version} ici.',
    papierMoins: 'Le texte seul donnait plus envie : {papier} sur le papier, {version} pour {nom}.',
    papierAutant: 'Autant d’envie que sur le papier : {papier} sur le papier, {version} pour {nom}.',
    indifferents: '{moins} laisse le moins d’indifférents ({pctMoins}), {plus} le plus ({pctPlus}).',
  },
  verbatims: {
    titre: 'Ce qu’ils en disent',
    interroger: 'Interroger ces jumeaux',
  },
  personas: {
    sousTitre: 'Ouvrez une fiche, puis parlez-lui de ce qu’il vient de voir : la conversation se garde.',
  },
}
